
import React, { Component } from 'react';

import { ByRoute } from '../../shared/decorators/routes.jsx';
import { ROUTES } from '../../shared/constants/routes.jsx';

import './index.scss';
import './responsive.scss'
import NewsPagesStore from '../../shared/api/news-pages.jsx';
import Markdown from '../../components/markdown/Markdown.jsx';
import NewsStore from '../../shared/api/news.jsx';

@ByRoute(ROUTES.newsDetails + '/:id')
class NewsDetails extends Component {

  state = {
    pageData : null,
    data     : null,
  }

  async componentDidMount() {
    const [pageData, news] = await Promise.all([
      NewsPagesStore.getData(),
      NewsStore.getData(),
    ]);
    const data = news.find(x => x.id === this.props.match.params.id);
    if (!data || !data.newsBlocks.length) {
      window.history.back();
    }
    this.setState({ pageData, data });
  }

  render() {
    const state = this.state;
    state.data && state.data.newsBlocks.sort((a, b) => a.position - b.position);

    return (state.pageData && state.data) ? (
      <div className="P-news-details G-page G-flex G-flex-column">
        {state.data.newsBlocks.map((item, index) => (
          item.image ? (index % 2 === 0) ? <div className="P-details-item G-flex" key={index}>
            <div className="P-details-image" style={{ backgroundImage: `url('${item.image}')` }}> </div>
            <div className="P-details-description">
              {index === 0 && <h2>{state.data.title}</h2>}
              <Markdown data={item.description} />
            </div>
          </div> : <div className="P-details-item G-flex" key={index}>
              <div className="P-details-description">
                <Markdown data={item.description} />
              </div>
              <div className="P-details-image" style={{ backgroundImage: `url('${item.image}')` }}> </div>
            </div> : <div className="P-details-item G-flex" key={index}>
              <div className="P-details-no-image P-details-description G-mb-6">
                <Markdown data={item.description} />
              </div>
            </div>
        ))}
      </div>
    ) : <div></div>
  }
}

export default NewsDetails;
